import { Maskonha } from "../../plugins/maskonha/maskonha"

export default function (payload = {}) {
  const {
    street = null, number = null, complement = null, district = null,
    city = null, state = null, zipcode
  } = payload
  return `${street} ${number} ${complement ? complement + ' ' : ''}- ${district} - ${city}/${state} - CEP: ${zipcode ? Maskonha.mask(zipcode, '00.000-000') : '-'}`
}
